// ./frontend/src/reducers/agencyReducer.js
import { SET_DOCKET_GENERAL_INFO,SET_PARTY_INFO,SET_DOCUMENT_TYPES,SET_REJECTED_PENDING_TYPES,SET_DOCKETS} from "../config";

const INITIAL_STATE={
  docketGenaralInfo:{
  }
}
export function docketGeneralInfoReducer(state = INITIAL_STATE, action) {
  switch(action.type) {
    case SET_DOCKET_GENERAL_INFO:
      state = {...state, ...action.docketGenaralInfo};
      return state;
  	case SET_PARTY_INFO:
      state = {...state, ...action.partyInfo};
      return state;
      case SET_DOCUMENT_TYPES:
      state = {...state, ...action.documentTypes};
      return state;
	  case SET_DOCKETS:
      state = {...state, caseids:action.caseids};
      return state;
	  case SET_REJECTED_PENDING_TYPES:
      state = {...state, ...action.externalDocumentTypes};
      return state;
    default:
      return state;
  }
}